// UI language, fixed per build (VITE_APP_LOCALE: en | ko | pt | es).
// Every catalogue in /messages is bundled lazily; only the selected one
// is downloaded. Unknown locales fall back to English.

type Messages = Record<string, unknown>;

const catalogues = import.meta.glob<{ default: Messages }>("../../messages/*.json");

export const locale: string = import.meta.env.VITE_APP_LOCALE || "en";

export async function loadMessages(): Promise<{ locale: string; messages: Messages }> {
  const load = catalogues[`../../messages/${locale}.json`] ?? catalogues["../../messages/en.json"];
  const resolved = catalogues[`../../messages/${locale}.json`] ? locale : "en";
  return { locale: resolved, messages: (await load()).default };
}
